import UNIQUE from '@/common/unique'

export default {
  id: 'division',
  name: 'division',
  type: 'standard',
  moduleName: 'editor_module_line',
  dataSet: {
    mods: 'division',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'division',
        value: '',
        detail: {
          options: ['division', 'radius']
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
